<div class="custom-toast" [ngClass]="{'show': visible}">
    <div class="toast-content">
      {{ message }}
    </div>
  </div>
  